'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _reactRhumb = require('react-rhumb');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _colors = require('HubStyleTokens/colors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _UICheckoutButton = require('ui-addon-upgrades/button/UICheckoutButton');

var _UICheckoutButton2 = _interopRequireDefault(_UICheckoutButton);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _ContactsSelectors = require('pricing-pages-unified-ui/selectors/ContactsSelectors');

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _ContactsPicker = require('../common/ContactsPicker');

var _ContactsPicker2 = _interopRequireDefault(_ContactsPicker);

var _FormattedReactMessage = require('I18n/components/FormattedReactMessage');

var _FormattedReactMessage2 = _interopRequireDefault(_FormattedReactMessage);

var _Editions = require('self-service-api/constants/Editions');

var _hasBackdoor = require('pricing-pages-unified-ui//utils/hasBackdoor');

var _hasBackdoor2 = _interopRequireDefault(_hasBackdoor);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _itemConfigUtils = require('pricing-pages-unified-ui/utils/itemConfigUtils');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _Terms = require('self-service-api/constants/Terms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataBox = (0, _styledComponents2.default)(_UIBox2.default).withConfig({
  displayName: 'SuiteContactsConfirmationPage__DataBox'
})(['&:nth-child(2){border-left:solid 1px ', ';border-right:solid 1px ', ';}'], _colors.BATTLESHIP, _colors.BATTLESHIP);

var DataWell = function DataWell(_ref) {
  var data = _ref.data,
      label = _ref.label,
      body = _ref.body;
  return _react2.default.createElement(
    DataBox,
    { grow: 1, basis: '33%', className: 'p-all-6' },
    _react2.default.createElement(
      'h3',
      { className: 'm-bottom-1' },
      data
    ),
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-2' },
      label
    ),
    _react2.default.createElement(
      _Small2.default,
      { use: 'help' },
      body
    )
  );
};

var SuiteContactsConfirmationPage = function (_React$Component) {
  _inherits(SuiteContactsConfirmationPage, _React$Component);

  function SuiteContactsConfirmationPage(props) {
    _classCallCheck(this, SuiteContactsConfirmationPage);

    var _this = _possibleConstructorReturn(this, (SuiteContactsConfirmationPage.__proto__ || Object.getPrototypeOf(SuiteContactsConfirmationPage)).call(this, props));

    _this.handleConfirm = function (e) {
      e.stopPropagation();
      _this.setState(function (prevState) {
        return { confirmed: !prevState.confirmed };
      });
    };

    var search = props.location.search;


    _this.state = _extends({
      confirmed: false
    }, props.location.state);

    var hasSuiteBackdoor = (0, _hasBackdoor2.default)('direct', search);
    if (hasSuiteBackdoor) {
      var _additionalUnitQuanti;

      _this.state = {
        confirmed: false,
        edition: _Editions.STARTER,
        additionalUnitQuantities: (_additionalUnitQuanti = {}, _defineProperty(_additionalUnitQuanti, _Hubs2.default.HUB_MARKETING, 0), _defineProperty(_additionalUnitQuanti, _Hubs2.default.HUB_SALES, 0), _defineProperty(_additionalUnitQuanti, _Hubs2.default.HUB_SERVICE, 0), _additionalUnitQuanti),
        term: _Terms.MONTHLY
      };
    }
    return _this;
  }

  _createClass(SuiteContactsConfirmationPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          history = _props.history,
          isLoadingPurchaseMotions = _props.isLoadingPurchaseMotions;

      if (!this.state.edition || isLoadingPurchaseMotions) {
        history.replace({ pathname: (0, _urls.getProductTabUrl)(_ProductsAndPlansNavIds.GROWTH_SUITE) });
      }
    }
  }, {
    key: 'getItemConfigs',
    value: function getItemConfigs() {
      var _state = this.state,
          edition = _state.edition,
          additionalUnitQuantities = _state.additionalUnitQuantities;

      return (0, _itemConfigUtils.createSuiteItemConfigs)(edition, additionalUnitQuantities);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          currencyCode = _props2.currencyCode,
          emailSendMultiplier = _props2.emailSendMultiplier,
          minPurchasableContacts = _props2.minPurchasableContacts,
          pricingDependencies = _props2.pricingDependencies,
          isLoadingPurchaseMotions = _props2.isLoadingPurchaseMotions;
      var _state2 = this.state,
          edition = _state2.edition,
          additionalUnitQuantities = _state2.additionalUnitQuantities,
          term = _state2.term,
          confirmed = _state2.confirmed;


      if (!edition || !additionalUnitQuantities || !term || isLoadingPurchaseMotions) return null;

      var termId = _GrowthSuiteEditionTermIdMap2.default[edition][term];

      var additionalUnitQuantity = additionalUnitQuantities[_Hubs2.default.HUB_MARKETING];

      var productName = _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL].productName;

      var pricingInfo = (0, _pricingUtils.calculateBundlePrice)({
        marketingPlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs2.default.HUB_MARKETING],
        salesPlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs2.default.HUB_SALES],
        servicePlanSelected: _SuiteEditionMerchIdMap2.default[edition][_Hubs2.default.HUB_SERVICE],
        marketingUnits: additionalUnitQuantities[_Hubs2.default.HUB_MARKETING],
        salesUnits: additionalUnitQuantities[_Hubs2.default.HUB_SALES],
        serviceUnits: additionalUnitQuantities[_Hubs2.default.HUB_SERVICE],
        term: term,
        pricingDependencies: pricingDependencies,
        isGrowthSuite: true
      });

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          {
            className: 'm-x-auto m-bottom-10 p-top-12',
            style: { maxWidth: '850px' }
          },
          _react2.default.createElement(_reactRhumb.NavMarker, { name: 'SUITE_CONTACTS_PAGE' }),
          _react2.default.createElement(
            'h2',
            { className: 'text-center m-bottom-10' },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.title' })
          ),
          _react2.default.createElement(
            _UITile2.default,
            { className: 'p-all-10' },
            _react2.default.createElement(
              _UIFlex2.default,
              { className: 'text-center' },
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_FormattedNumber2.default, {
                  value: minPurchasableContacts + additionalUnitQuantity
                }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contacts.title' }),
                body: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contacts.text' })
              }),
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_FormattedNumber2.default, {
                  value: (minPurchasableContacts + additionalUnitQuantity) * emailSendMultiplier
                }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.emailSends.title' }),
                body: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.emailSends.text' })
              }),
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_PriceDisplay2.default, {
                  price: pricingInfo.monthly.calculatedPrice,
                  currencyCode: currencyCode
                }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.perMonthExtended' }),
                body: _react2.default.createElement(_FormattedReactMessage2.default, {
                  message: 'contactConfirmation.pricing.text',
                  options: {
                    numberOfContacts: minPurchasableContacts + additionalUnitQuantity,
                    productName: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.title.starter' })
                  }
                })
              })
            ),
            _react2.default.createElement(_ContactsPicker2.default, {
              merchandiseId: _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL,
              additionalUnitQuantity: additionalUnitQuantity,
              onChange: function onChange(value) {
                return _this2.setState({
                  additionalUnitQuantities: _extends({}, additionalUnitQuantities, _defineProperty({}, _Hubs2.default.HUB_MARKETING, value))
                });
              },
              termId: termId
            })
          ),
          _react2.default.createElement(
            _UISelectableBox2.default,
            {
              selected: confirmed,
              onSelectedChange: this.handleConfirm,
              className: 'text-left p-top-6 m-top-6'
            },
            _react2.default.createElement(
              'h5',
              { className: 'm-bottom-3' },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.confirmationBoxTitle' })
            ),
            _react2.default.createElement(
              'p',
              { style: { fontWeight: 'normal' } },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'contactConfirmation.confirmationBoxBody',
                options: { productName: productName }
              })
            ),
            _react2.default.createElement(
              _UICheckbox2.default,
              {
                checked: confirmed,
                onChange: this.handleConfirm,
                'data-selenium-id': 'contact-tier-accept-terms-button'
              },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'contactConfirmation.confirmationBoxCheckbox',
                style: { fontWeight: 600 }
              })
            )
          ),
          _react2.default.createElement(
            _UICheckoutButton2.default,
            {
              className: 'm-top-6',
              disabled: !confirmed,
              upgradeData: {
                app: _Tracking.APP,
                screen: _Tracking.SCREENS.SUITE_CONTACT_CONFIRMATION,
                upgradeProduct: 'suite-' + _Editions.STARTER,
                uniqueId: _Tracking.SCREENS.SUITE_CONTACT_CONFIRMATION + '-' + _Editions.STARTER
              },
              use: 'primary',
              itemConfigurations: this.getItemConfigs(),
              currencyCode: currencyCode,
              termId: termId,
              style: { marginLeft: 0 },
              additionalUnitQuantity: additionalUnitQuantity,
              'data-selenium-id': _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL + '-checkout-contacts-button'
            },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.continue' })
          )
        )
      );
    }
  }]);

  return SuiteContactsConfirmationPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  var isLoadingPurchaseMotions = state.purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED;

  if (isLoadingPurchaseMotions) return { isLoadingPurchaseMotions: isLoadingPurchaseMotions };

  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    emailSendMultiplier: (0, _ContactsSelectors.emailSendMultiplierSelector)(state, _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL),
    minPurchasableContacts: (0, _ContactsSelectors.minPurchasableContactsSelector)(state, _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL),
    isLoadingPurchaseMotions: isLoadingPurchaseMotions
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(SuiteContactsConfirmationPage));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/contacts-confirmation-page/SuiteContactsConfirmationPage.js
// module id = 786
// module chunks = 3 4